<template>
  <div class="info-card">
    <v-menu
      open-on-hover
      bottom
      left
      offset-y
      max-width="768"
    >
      <div slot="activator">
        {{ label }}
        <component :is="childComponent.labelComponent"  v-bind="{...(childComponent && childComponent.props)}" v-if="childComponent && childComponent.labelComponent">
          <slot />
        </component>
      </div>
      <v-card>
        <div
          class="info-card-body"
          title="Click to copy to clipboard"
          @click="onInfoBodyClick"
        >      
        <div v-html="infoString" v-if="infoString"></div>
        <component :is="childComponent.component"  v-bind="{...(childComponent && childComponent.props)}" v-if="childComponent">
          <slot />
        </component>
        </div>  
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { NotificationService } from "../notification/notification.service";
export default {
  props: {
    infoString: String,
    label: String,
    childComponent: {
      type: [String, Object],
      default: '',
    }
  },
  data: function () {
    return {
      copyFlag: false,
    };
  },
  methods: {
    onInfoBodyClick: function (event) {
      const body = event.target;

      navigator.clipboard.writeText(body.innerText).then(
        function () {
          console.log(
            "Async: Copying to clipboard was successful!"
          );
          NotificationService.showNotification({
            text: "Info copied to Clipboard",
            timeout: 1000,
          });
        },
        function (err) {
          console.error(
            "Async: Copying to clipboard was not successful!"
          );
          NotificationService.showNotification({
            text: "Text could not be copied to clipboard",
            timeout: 2000,
            type: "error",
          });
        }
      );
    },
    //MARK: METHODS
  },
};
</script>

<style lang="scss">
.info-card-body {
  border: 1px solid rgba(145, 145, 145, 0.479);
  cursor: copy;
  padding: 10px;
  max-width: 500px;
  max-height: 400px;
  overflow: auto;
  word-wrap: break-word;
}
</style>